import { render, staticRenderFns } from "./DogABTest.vue?vue&type=template&id=1ae20be7&scoped=true"
import script from "./DogABTest.vue?vue&type=script&lang=js"
export * from "./DogABTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae20be7",
  null
  
)

export default component.exports